import React from "react";
import PropTypes from "prop-types";

import { UISelectCard } from "../../../../ui";
import {
  fillTemplate,
  formatAmount,
  formatCrewSizePrice,
  getCrewSizeFee,
} from "./crewSizeUtils";

const CrewSizeOptions = ({
  containerRef,
  t,
  options,
  model,
  selectedId,
  invalid,
  disabled,
  onSelect,
}) => (
  <div
    ref={containerRef}
    className="crew-size-step__options"
    role="radiogroup"
    aria-label={t.title}
    aria-invalid={invalid || undefined}
  >
    {options.map((option) => {
      const fee = getCrewSizeFee(option, model);
      return (
        <UISelectCard
          key={option.id}
          selectionRole="radio"
          size="md"
          title={option.name}
          meta={[
            option.min <= 1
              ? fillTemplate(t.upTo, { max: formatAmount(option.max) })
              : fillTemplate(t.range, {
                  min: formatAmount(option.min),
                  max: formatAmount(option.max),
                }),
            formatCrewSizePrice(t, fee, model),
          ].filter(Boolean)}
          selected={option.id === selectedId}
          invalid={invalid}
          disabled={disabled}
          onClick={() => onSelect(option)}
        />
      );
    })}
  </div>
);

CrewSizeOptions.propTypes = {
  /** Lets the step scroll the cards into view when they are marked as missing. */
  containerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  t: PropTypes.object.isRequired,
  /** Standard crew size options built with `toCrewSizeOption`. */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      name: PropTypes.string,
      min: PropTypes.number,
      max: PropTypes.number,
      /** Fees of the size for the company's plan, as the backend returns them. */
      dailyFee: PropTypes.number,
      monthlyFee: PropTypes.number,
    }),
  ).isRequired,
  /** Daily or extended: whether the fee reads per day or flat. */
  model: PropTypes.string.isRequired,
  selectedId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** No size was chosen when "Next" was pressed. */
  invalid: PropTypes.bool,
  disabled: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
};

CrewSizeOptions.defaultProps = {
  containerRef: undefined,
  selectedId: null,
  invalid: false,
  disabled: false,
};

export default CrewSizeOptions;
